import { getUnderscoreToCamelcaseText } from "../helpers/get-underscore-to-camelcase-text";
import statsigEnv from "./statsig-host";

export default (str = "") => {
    const envPrefix = statsigEnv();

    if (str.includes(`${envPrefix}_`)) {
        str = str.replace(`${envPrefix}_`, "");
    }

    return getUnderscoreToCamelcaseText(str);
};
